import { useState, type FormEvent } from 'react'
import { login, type Session } from '../lib/auth'

type LoginPageProps = {
  onLogin: (session: Session) => void
}

export default function LoginPage({ onLogin }: LoginPageProps) {
  const [username, setUsername] = useState('guest')
  const [password, setPassword] = useState('guest')
  const [error, setError] = useState('')
  const [submitting, setSubmitting] = useState(false)

  const submit = async (event: FormEvent) => {
    event.preventDefault()
    setError('')
    setSubmitting(true)

    try {
      onLogin(await login(username.trim(), password))
    } catch (loginError) {
      setError(loginError instanceof Error ? loginError.message : '로그인하지 못했습니다.')
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <section className="login-section section-container">
      <div className="login-copy">
        <span className="eyebrow">KEYWORD STATISTICS</span>
        <h1>키워드 데이터를 간단하게 확인하세요.</h1>
        <p>기본 계정은 guest / guest입니다. 로그인 상태는 현재 브라우저 탭에서만 유지됩니다.</p>
      </div>

      <form className="login-card" onSubmit={submit}>
        <div>
          <span className="eyebrow">SIGN IN</span>
          <h2>로그인</h2>
        </div>
        <label>
          아이디
          <input value={username} autoComplete="username" onChange={(event) => setUsername(event.target.value)} />
        </label>
        <label>
          비밀번호
          <input
            type="password"
            value={password}
            autoComplete="current-password"
            onChange={(event) => setPassword(event.target.value)}
          />
        </label>
        {error && <p className="form-error" role="alert">{error}</p>}
        <button className="button button-primary" disabled={submitting}>
          {submitting ? '확인 중…' : '로그인'}
        </button>
        <p className="form-note">이 로그인은 공개 데이터 화면의 진입 구분용이며 강한 보안 수단은 아닙니다.</p>
      </form>
    </section>
  )
}
